module.exports = __webpack_public_path__ + "img/houseType3.d382730f.jpg";